import { render, staticRenderFns } from "./Gewerkt.vue?vue&type=template&id=1be0052c&scoped=true&"
import script from "./Gewerkt.vue?vue&type=script&lang=js&"
export * from "./Gewerkt.vue?vue&type=script&lang=js&"
import style0 from "./Gewerkt.vue?vue&type=style&index=0&id=1be0052c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0052c",
  null
  
)

export default component.exports